import { h, FunctionComponent } from 'preact';

interface Props {
	trackingLabels: string[];
}

const generateColor = function (index: number) {
	return `hsl(${index * 105.508}, 70%, 50%)`; // use golden angle approximation
};

const TrackingLabels: FunctionComponent<Props> = ({ trackingLabels }) => {
	return (
		<div className="tracking-labels" data-testid="tracking-labels">
			{trackingLabels.map((label, index) => (
				<div
					key={label}
					className="tracking-label"
					data-testid={`tracking-label-${label}`.trim()}
					style={{ backgroundColor: generateColor(index) }}
				>
					{label}
				</div>
			))}
		</div>
	);
};

export default TrackingLabels;
